export default "__VITE_ASSET__d21acd72__"